import React, { useContext } from "react";
import { popupcontext } from "../../../../context/Popupscontext";
import { DriverPopup } from "../../../Drivers/DriverPopUp/DriverPopUp";
import { VehiclePopup } from "../../../Vehicles/VehiclePopUp/VehiclePopUp";
import { UsersPopup } from "../../../Users/UsersPopUp/UsersPopup";
import GeofencePopup from "../../../Geofences/GeofencePopup/GeofencePopup";
import TechnicianPopup from "../../../Facility-Management/Technicians/Popup/TechnicianPopup";
import RegularPopup from "../../../Maintenance/RegularMaintenance/RegularPopup/RegularPopup";
import FormsPopup from "../../../Workforce/Forms/FormsPopup/FormsPopup";
import POIsPopup from "../../../POIs/POIsPopup/POIsPopup";
import { TaskPopup } from "../../../Tasks/Popups/TaskPopup";
import ViewRequest from "../../../Requests/ViewRequsetPopup/ViewRequest";
import { CustomersPopup } from "../../../Customers/CustomersPopUp/CustomersPopup";
import { PermissionsPopup } from "../../../Roles&Permissions/Permissions/PermissionsPopup/PermissionsPopup";
import { RolesPopup } from "../../../Roles&Permissions/Roles/RolesPopup/RolesPopup";
import ViewSnag from "../../../Snag/ViewSnagPopup/ViewSnag";
import { InspectonRequestPopup } from "../../../InspectionRequest/InspectionRequestPopup/InspectonRequestPopup";
import SubmitalsPopup from "../../../Submittals/SubmittalsPopup/SubmitalsPopup";
import { CompanyPopup } from "../../../Companies/CompanyPopup/CompanyPopup";
import { TeamPopup } from "../../../Teams/TeamPopup/TeamPopup";
import { TeamMemberPopup } from "../../../Teams/TeamPopup/TeamMemberPopup";

export default function Display({
  vehicleId,
  DriverId,
  userId,
  subuserId,
  GeoId,
  type,
  show,
  technicianId,
  maintenanceId,
  formId,
  taskId,
  poiId,
  requestId,
  permissionId,
  roleId,
  customerId,
  snagId,
  irId,
  submittalId,
  companyId,
  teamId,
  memberId,
}) {
  const {
    currentVehicleId,
    currentDriverId,
    currentUserId,
    currentSubUserId,
    currentGeofenceId,
    currentFormId,
    showDetails,
    isDeleting,
    isEditing,
    setIsDeleting,
    currentTechnicianId,
    currentMaintenanceId,
    currentTaskId,
    currentPOIId,
    currentRequestId,
    currentPermissionId,
    currentRoleId,
    currentCustomerId,
    currentSnagId,
    currentIRId,
    currentSubmittalId,
    currentCompanyId,
    currentTeamId,
    currentMemberId,
    setuserPopup,
    userPopup,
    handleClose,
  } = useContext(popupcontext);

  const handleDisplayClick = () => {
    if (isDeleting) {
      setIsDeleting(false);
    }
    if (vehicleId) showDetails("vehicles", vehicleId);

    if (DriverId) {
      showDetails("drivers", DriverId);
    }
    if (userId) {
      showDetails("users", userId);
    }
    if (subuserId) {
      showDetails("subusers", subuserId);
    }
    if (GeoId) {
      showDetails("geofences", GeoId);
    }
    if (technicianId) {
      showDetails("technician", technicianId);
    }
    if (technicianId) {
      showDetails("technician", technicianId);
    }
    if (maintenanceId) {
      showDetails("maintenance", maintenanceId);
    }
    if (taskId) {
      showDetails("task", taskId);
    }
    if (poiId) {
      showDetails("pois", poiId);
    }
    if (permissionId) {
      showDetails("permission", permissionId);
    }
    if (roleId) {
      showDetails("role", roleId);
    }
    if (customerId) {
      showDetails("customer", customerId);
    }
    if (snagId) {
      showDetails("snag", snagId);
    }
    if (irId) {
      showDetails("IR", irId);
    }
    if (submittalId) {
      showDetails("submittal", submittalId);
    }
    if (companyId) {
      showDetails("company", companyId);
    }
    if (teamId) {
      showDetails("team", teamId);
    }
    if (memberId) {
      showDetails("member", memberId);
    }
  };

  const closeTask = () => {
    handleClose("display");
    console.log("currentCompanyId", currentCompanyId);
  };

  return (
    <>
      {show && (
        <img
          role="button"
          src={`${process.env.PUBLIC_URL}/assets/Eye.svg`}
          alt="show"
          onClick={handleDisplayClick}
          title="display"
        />
      )}
      {currentVehicleId === vehicleId &&
        isEditing === false &&
        isDeleting === false && <VehiclePopup vehicleId={currentVehicleId} />}
      {currentDriverId === DriverId &&
        isEditing === false &&
        isDeleting === false && <DriverPopup DriverId={currentDriverId} />}
      {currentUserId === userId &&
        isEditing === false &&
        isDeleting === false &&
        type === "link" && <UsersPopup userId={currentUserId} type="user" />}
      {currentSubUserId === subuserId &&
        isEditing === false &&
        isDeleting === false && (
          <UsersPopup userId={currentSubUserId} type="subuser" />
        )}
      {currentGeofenceId === GeoId &&
        isEditing === false &&
        isDeleting === false && (
          <GeofencePopup GeoId={currentGeofenceId} type="geofence" />
        )}
      {currentTechnicianId === technicianId &&
        isEditing === false &&
        isDeleting === false && (
          <TechnicianPopup technicianId={technicianId} type="technician" />
        )}
      {currentMaintenanceId === maintenanceId &&
        isEditing === false &&
        isDeleting === false && (
          <RegularPopup id={maintenanceId} type="maintenance" />
        )}
      {currentFormId === formId &&
        isEditing === false &&
        isDeleting === false && (
          <FormsPopup formId={currentFormId} type="form" />
        )}
      {currentTaskId === taskId &&
        isEditing === false &&
        isDeleting === false && (
          <TaskPopup taskId={taskId} onClose={closeTask} />
        )}
      {currentPOIId === poiId &&
        isEditing === false &&
        isDeleting === false &&
        type !== "projectSetup" && <POIsPopup poiId={currentPOIId} />}
      {currentRequestId === requestId &&
        isEditing === false &&
        isDeleting === false && <ViewRequest requestId={currentRequestId} />}
      {currentCustomerId === customerId &&
        isEditing === false &&
        isDeleting === false &&
        type === "customer" && (
          <CustomersPopup customerId={currentCustomerId} type="customer" />
        )}
      {currentPermissionId === permissionId &&
        isEditing === false &&
        isDeleting === false && (
          <PermissionsPopup permissionId={permissionId} />
        )}
      {currentRoleId === roleId &&
        isEditing === false &&
        isDeleting === false && <RolesPopup roleId={roleId} />}
      {currentSnagId === snagId &&
        isEditing === false &&
        isDeleting === false && <ViewSnag snagId={currentSnagId} />}
      {currentIRId === irId && isEditing === false && isDeleting === false && (
        <InspectonRequestPopup irId={irId} />
      )}{" "}
      {currentSubmittalId === submittalId &&
        isEditing === false &&
        isDeleting === false && <SubmitalsPopup submittalId={submittalId} />}
      {currentCompanyId === companyId &&
        isEditing === false &&
        isDeleting === false && (
          <CompanyPopup companyId={currentCompanyId} onClose={closeTask} />
        )}
      {currentTeamId === teamId &&
        isEditing === false &&
        isDeleting === false && (
          <TeamPopup teamId={currentTeamId} onClose={closeTask} />
        )}
      {currentMemberId === memberId &&
        isEditing === false &&
        isDeleting === false && (
          <TeamMemberPopup memberId={currentMemberId} onClose={closeTask} />
        )}
    </>
  );
}
